import React from 'react';
import { View } from 'react-native';
import { useQuery } from '@apollo/client';
import { useForm } from 'react-hook-form';
import styled from 'styled-components/native';

import { Button } from 'app/src/elements/buttons';
import { defaultValues } from 'app/src/elements/forms';
import Input from 'app/src/elements/inputs';
import { Text } from 'app/src/styles';

import { SHOPIFY_PAYMENTS_WORKSHEET } from './queries';

const Fields = styled(View)`
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;

const ShopifyPaymentsWorksheet = () => {
  const { data, loading, refetch } = useQuery(
    SHOPIFY_PAYMENTS_WORKSHEET,
    { fetchPolicy: 'no-cache', notifyOnNetworkStatusChange: true }
  );

  const { control, handleSubmit } = useForm({
    defaultValues: { fromDate: '', toDate: '' }
  });

  const onSubmit = input => {
    refetch({ fromDate: input.fromDate || null, toDate: input.toDate || null });
  };

  return (
    <View>
      <Fields>
        <Text style={{ fontWeight: 600 }}>
          Custom Dates
        </Text>

        <Text>From:</Text>
        <Input.Date
          name="fromDate"
          control={control}
        />

        <Text>To:</Text>
        <Input.Date
          name="toDate"
          control={control}
        />

        <Button
          label="Update"
          onPress={handleSubmit(onSubmit)}
        />
      </Fields>

      <Text>
        Below are shopify orders marked as paid outside of Shopify, that were
        updated in the past 5 days (by default; that can be changed using the
        form above). Note that this uses order updated date, not paid date,
        because I can't figure out how to filter by paid date that in the
        Shopify API.
      </Text>

      <Text>
        This is intended to help with reconciling Gravity payments and
        cash/check deposits.
      </Text>

      {loading && <Text>Loading...</Text>}

      <Text style={{ whiteSpace: 'pre', marginTop: 20 }}>
        {data?.shopifyPaymentsWorksheet}
      </Text>
    </View>
  );
};

export default ShopifyPaymentsWorksheet;
